import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

import { Auth } from 'src/providers/auth/auth';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { CookieProvider } from 'src/providers/cookie/cookie';
import { Me } from 'src/providers/me/me';
import { Proposals } from 'src/providers/proposals/proposals';
import { UtmService } from 'src/providers/utm/utm.service';

import { validateEmail } from 'src/shared/validator/validateEmail';

@Component({
    templateUrl: 'log-in-to-book.html',
    standalone: false
})

export class LogInToBookPage implements OnInit {

  errorMessage: string;
  form: UntypedFormGroup;
  proposal: any;
  submitted: boolean;


  boundLogIn = this.logIn.bind(this);

constructor(
    private auth: Auth,
    private _fb: UntypedFormBuilder,
    private cookieProvider: CookieProvider,
    private me: Me,
    private navCtrl: CustomNavController,
    private proposals: Proposals,
    private utmService: UtmService
  ) {
    this.form = this._fb.group({
      email: ['', Validators.compose([Validators.required, validateEmail])],
      password: ['', Validators.required]
    });
  }

  ngOnInit() {
    // Capture UTMs from URL if present
    this.utmService.captureUtmsFromUrl();
    this.proposal = this.navCtrl.getParam('proposal');
    this.form.patchValue({email: this.proposal.customer.email});
  }

  async logIn() {
    this.submitted = true;
    this.errorMessage = '';
    if (this.proposal.customer.email !== this.form.value.email) {
      return this.errorMessage = 'This proposal was sent to a different user. Please log into the user the proposal was sent to.';
    }
    if (!this.form.valid) {
      return;
    }
    const credentials = this.buildCredentials();
    try {
      await this.auth.login(credentials, 'login');
      await this.loadAccount();
      localStorage.setItem('addressId', this.proposal.customer.address_ids[0]);
      this.proposals.goToBookJob(this.proposal);
    } catch (err) {
      this.errorMessage = 'The email and password you entered did not match our records. Please double-check and try again.';
    }
  }

  buildCredentials(): any {
    const utms = this.utmService.getUtmsForAuth();
    return {
      username: this.form.value.email,
      password: this.form.value.password,
      date_added_to_cookie: utms.date_added_to_cookie,
      utm_source: utms.utm_source,
      utm_medium: utms.utm_medium,
      utm_campaign: utms.utm_campaign,
      utm_term: utms.utm_term,
      utm_content: utms.utm_content
    };
  }

  loadAccount() {
    return this.me.load().then(async account => {
      const customerObj: any = account;
      this.auth.setAccountTypeStorage(customerObj.account_type);
      this.auth.setSession();
    });
  }

  goToClientHub() {
    const clientHubUuId = this.navCtrl.getParam('clientHubUuId');
    this.navCtrl.navigateForward(`client/${clientHubUuId}`);
  }
}
